const docuToolsOrange = {
  'dt-10': '#FCEEE8',
  'dt-20': '#FDBEA7',
  orange: '#FF6633',
  'dt-40': '#FF5118',
  'dt-50': '#F13D00',
  'dt-60': '#BA2D00',
  'dt-70': '#851F00'
}

const greys = {
  black: '#000000',
  'grey-100': '#141A21',
  'grey-90': '#2D323B',
  'grey-80': '#464954',
  'grey-70': '#5F616E',
  'grey-60': '#787887',
  'grey-50': '#A0A0AA',
  'grey-40': '#BEBEC7',
  'grey-30': '#DCDCE4',
  'grey-20': '#EDEDF1',
  'grey-10': '#F6F6FA',
  'grey-05': '#FBFBFD',
  white: '#FFFFFF'
}

const secondaryColors = {
  darkgreen: {
    pale: '#CBE6EA',
    normal: '#008556',
    strong: '#007749'
  },
  green: {
    pale: '#E9F7DD',
    normal: '#91D656',
    strong: '#8DC953'
  },
  turquoise: {
    pale: '#CCF6F4',
    normal: '#00D3C9',
    strong: '#00C8BD'
  },
  petrol: {
    pale: '#D7E8EB',
    normal: '#398D9B',
    strong: '#34848C'
  },
  darkblue: {
    pale: '#D4DEEF',
    normal: '#2859AF',
    strong: '#2758A0'
  },
  blue: {
    pale: '#DBE8FA',
    normal: '#4D8CE8',
    strong: '#5485D3'
  },
  violet: {
    pale: '#ECDEF7',
    normal: '#A25AD6',
    strong: '#9155C6'
  },
  purple: {
    pale: '#F4DFEE',
    normal: '#C95FAB',
    strong: '#B758A1'
  },
  pink: {
    pale: '#FFE0E8',
    normal: '#FF668E',
    strong: '#F2618D'
  },
  red: {
    pale: '#FBDADA',
    normal: '#EA4444',
    strong: '#D64949'
  },
  orange: {
    pale: '#FFEAD6',
    normal: '#FF9533',
    strong: '#F98A3E'
  },
  yellow: {
    pale: '#FFF4D8',
    normal: '#FFC93E',
    strong: '#F2BA3D'
  },
  ochre: {
    pale: '#F8F1E5',
    normal: '#DDBB7C',
    strong: '#CCA77A'
  },
  muesli: {
    pale: '#EBE6DE',
    normal: '#99815B',
    strong: '#8C7554'
  },
  darkbrown: {
    pale: '#DEDCD9',
    normal: '#5B5142',
    strong: '#4C4338'
  }
}

const semantics = {
  success: {
    pale: '#E9F7DD',
    normal: '#91D656',
    strong: '#8DC953'
  },
  info: {
    pale: '#DBE8FA',
    normal: '#4D8CE8',
    strong: '#5485D3'
  },
  danger: {
    'error-10': '#FBDADA',
    'error-20': '#F3B7AF',
    'error-30': '#EE7A6F',
    error: '#EA4444',
    'error-50': '#D64949',
    'error-60': '#C13435'
  },
  warning: {
    pale: '#FFEAD6',
    normal: '#FF9533',
    strong: '#F98A3E'
  },
  inactive: '#A0A0AA',
  cta: '#FF6633'
}

export const hexToRgb = (hex, alpha) => {
  let r = 0
  let g = 0
  let b = 0

  // 3 digits
  if (hex.length === 4) {
    r = `0x${hex[1]}${hex[1]}`
    g = `0x${hex[2]}${hex[2]}`
    b = `0x${hex[3]}${hex[3]}`

    // 6 digits
  } else if (hex.length === 7) {
    r = `0x${hex[1]}${hex[2]}`
    g = `0x${hex[3]}${hex[4]}`
    b = `0x${hex[5]}${hex[6]}`
  }

  if (alpha) {
    return { r: +r, g: +g, b: +b, a: alpha }
  }

  return { r: +r, g: +g, b: +b }
}

export const rgbToHex = ({ r, g, b } = {}) => {
  const toHex = (value) => {
    const hex = value.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }

  if (!!r && !!g && !!b) {
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`
  }

  return greys['grey-100']
}

export const applyOpacity = (color, opacity) => {
  const rgb = hexToRgb(color)
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`
}

// all normal colors

export const pinColorOptions = {
  DARKBROWN: 'DarkBrown',
  MUESLI: 'Muesli',
  OCHRE: 'Ochre',
  YELLOW: 'Yellow',
  ORANGE: 'Orange',
  RED: 'Red',
  PINK: 'Pink',
  PURPLE: 'Purple',
  VIOLET: 'Violet',
  BLUE: 'Blue',
  DARKBLUE: 'DarkBlue',
  PETROL: 'Petrol',
  TURQUOISE: 'Turquoise',
  GREEN: 'Green',
  DARKGREEN: 'DarkGreen'
}

export const pinsColors = {
  [pinColorOptions.DARKBROWN]: secondaryColors.darkbrown.normal,
  [pinColorOptions.MUESLI]: secondaryColors.muesli.normal,
  [pinColorOptions.OCHRE]: secondaryColors.ochre.normal,
  [pinColorOptions.YELLOW]: secondaryColors.yellow.normal,
  [pinColorOptions.ORANGE]: secondaryColors.orange.normal,
  [pinColorOptions.RED]: secondaryColors.red.normal,
  [pinColorOptions.PINK]: secondaryColors.pink.normal,
  [pinColorOptions.PURPLE]: secondaryColors.purple.normal,
  [pinColorOptions.VIOLET]: secondaryColors.violet.normal,
  [pinColorOptions.BLUE]: secondaryColors.blue.normal,
  [pinColorOptions.DARKBLUE]: secondaryColors.darkblue.normal,
  [pinColorOptions.PETROL]: secondaryColors.petrol.normal,
  [pinColorOptions.TURQUOISE]: secondaryColors.turquoise.normal,
  [pinColorOptions.GREEN]: secondaryColors.green.normal,
  [pinColorOptions.DARKGREEN]: secondaryColors.darkgreen.normal
}

export const pinsRGBColors = {
  [pinColorOptions.DARKBROWN]: hexToRgb(secondaryColors.darkbrown.normal),
  [pinColorOptions.MUESLI]: hexToRgb(secondaryColors.muesli.normal),
  [pinColorOptions.OCHRE]: hexToRgb(secondaryColors.ochre.normal),
  [pinColorOptions.YELLOW]: hexToRgb(secondaryColors.yellow.normal),
  [pinColorOptions.ORANGE]: hexToRgb(secondaryColors.orange.normal),
  [pinColorOptions.RED]: hexToRgb(secondaryColors.red.normal),
  [pinColorOptions.PINK]: hexToRgb(secondaryColors.pink.normal),
  [pinColorOptions.PURPLE]: hexToRgb(secondaryColors.purple.normal),
  [pinColorOptions.VIOLET]: hexToRgb(secondaryColors.violet.normal),
  [pinColorOptions.BLUE]: hexToRgb(secondaryColors.blue.normal),
  [pinColorOptions.DARKBLUE]: hexToRgb(secondaryColors.darkblue.normal),
  [pinColorOptions.PETROL]: hexToRgb(secondaryColors.petrol.normal),
  [pinColorOptions.TURQUOISE]: hexToRgb(secondaryColors.turquoise.normal),
  [pinColorOptions.GREEN]: hexToRgb(secondaryColors.green.normal),
  [pinColorOptions.DARKGREEN]: hexToRgb(secondaryColors.darkgreen.normal)
}

// All strong colors
export const categoryColors = {
  [pinColorOptions.OCHRE]: secondaryColors.ochre.strong,
  [pinColorOptions.YELLOW]: secondaryColors.yellow.strong,
  [pinColorOptions.ORANGE]: secondaryColors.orange.strong,
  [pinColorOptions.RED]: secondaryColors.red.strong,
  [pinColorOptions.PINK]: secondaryColors.pink.strong,
  [pinColorOptions.PURPLE]: secondaryColors.purple.strong,
  [pinColorOptions.VIOLET]: secondaryColors.violet.strong,
  [pinColorOptions.BLUE]: secondaryColors.blue.strong,
  [pinColorOptions.DARKBLUE]: secondaryColors.darkblue.strong,
  [pinColorOptions.PETROL]: secondaryColors.petrol.strong,
  [pinColorOptions.TURQUOISE]: secondaryColors.turquoise.strong,
  [pinColorOptions.GREEN]: secondaryColors.green.strong,
  [pinColorOptions.DARKGREEN]: secondaryColors.darkgreen.strong,
  [pinColorOptions.MUESLI]: secondaryColors.muesli.strong,
  [pinColorOptions.DARKBROWN]: secondaryColors.darkbrown.strong
}

export const categoryBgColors = {
  [pinColorOptions.OCHRE]: secondaryColors.ochre.pale,
  [pinColorOptions.YELLOW]: secondaryColors.yellow.pale,
  [pinColorOptions.ORANGE]: secondaryColors.orange.pale,
  [pinColorOptions.RED]: secondaryColors.red.pale,
  [pinColorOptions.PINK]: secondaryColors.pink.pale,
  [pinColorOptions.PURPLE]: secondaryColors.purple.pale,
  [pinColorOptions.VIOLET]: secondaryColors.violet.pale,
  [pinColorOptions.BLUE]: secondaryColors.blue.pale,
  [pinColorOptions.DARKBLUE]: secondaryColors.darkblue.pale,
  [pinColorOptions.PETROL]: secondaryColors.petrol.pale,
  [pinColorOptions.TURQUOISE]: secondaryColors.turquoise.pale,
  [pinColorOptions.GREEN]: secondaryColors.green.pale,
  [pinColorOptions.DARKGREEN]: secondaryColors.darkgreen.pale,
  [pinColorOptions.MUESLI]: secondaryColors.muesli.pale,
  [pinColorOptions.DARKBROWN]: secondaryColors.darkbrown.pale
}

export const taskStatusColor = {
  Done: semantics.success.pale,
  Overdue: semantics.danger['error-10'],
  Rejected: semantics.danger['error-10'],
  Closed: semantics.info.pale,
  Open: greys['grey-05'],
  Inactive: `repeating-linear-gradient(135deg, ${greys['grey-10']} 2%, #fff 2%, #fff 6%, ${greys['grey-10']} 6%, ${greys['grey-10']} 15%, #fff 15%, #fff 15%, ${greys['grey-10']} 15%)` // not-found
}

export { docuToolsOrange, greys, secondaryColors, semantics }

const colorsOptions = { docuToolsOrange, greys, secondaryColors, semantics }

export default colorsOptions
